import { Result } from 'antd';

function NotAuthorizedPage() {
	return (
		<Result
			status="info"
			title={<h2>No Access</h2>}
			className="sss"
			style={{ position: 'relative', top: '50%', left: '50%', transform: 'translate(-50%,-50%)' }}
			subTitle={<h4>You are not authorized to access.</h4>}
		/>
	);
}

export default NotAuthorizedPage;
